import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Radio from './utils/Checkout.Radio';
import {
  setDelivery,
  setShippingConfirmed,
} from '../../Actions/Checkout.action';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

const DeliveryMethods = () => {
  const dispatch = useDispatch();
  const checkout = useTypedSelector((state) => state.checkout);
  const { deliveryMethods, selectedDeliveryMethod } = checkout.payload;

  useEffect(() => {
    if (selectedDeliveryMethod || !deliveryMethods[0]) return;

    dispatch(setDelivery(deliveryMethods[0]));
    dispatch(setShippingConfirmed(false));
  }, []);

  return deliveryMethods && deliveryMethods.length > 1 ? (
    <>
      {deliveryMethods.map((method) => (
        <Radio
          key={method.id + 'delivery-method'}
          title={method.name}
          description={method.description}
          cost={method.formattedPrice}
          logo={
            method.imageUrl && (
              <img src={method.imageUrl} alt={method.name} />
            )
          }
          stateKey={'delivery-method'}
          id={method.id}
          checked={method.id === selectedDeliveryMethod?.id}
          onChange={() => dispatch(setDelivery(method))}
        />
      ))}
    </>
  ) : null;
};

export default DeliveryMethods;
